import { marked } from 'marked';
import { extractGeneratedStylesheets, sanitizeHtml } from '../utils/sanitizeHtml.mjs';

type Props = {
  className: string;
  content: string;
  format?: 'html' | 'markdown' | 'generated';
};

export function SanitizedHtml({ className, content, format = 'html' }: Props) {
  const html = format === 'markdown'
    ? marked.parse(content, { async: false })
    : format === 'generated'
      ? content.replace(/^```html\s*/i, '').replace(/\s*```$/, '')
        .replace(/^html\\n/i, '').replace(/\\n/g, '\n').trim()
      : content;

  const stylesheets = format === 'generated' ? extractGeneratedStylesheets(html) : [];
  return <>
    {stylesheets.map((href) => <link key={href} rel="stylesheet" href={href} />)}
    <div className={className} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />
  </>;
}
